<template>
  <div class="reset-password-view">
    <div class="form-side">
      <div
        class="reset-password-pane"
        v-if="!userResetTokenExpiredFlag && !userResetTokenNotFoundFlag && !isCalling"
      >
        <div
          class="logo"
          @click="goToSignin"
        >
          <img
            alt="Fuell logo"
            :src="require('@/assets/img/logo.svg')"
          >
        </div>
        <reset-password-form @resetPassword="resetPassword" />
      </div>
      <div
        class="d-flex flex-column align-items-center justify-content-center reset-password-pane--error"
        v-else-if="!isCalling"
      >
        <div
          class="logo"
          @click="goToSignin"
        >
          <img
            alt="Fuell logo my-5"
            :src="require('@/assets/img/logo.svg')"
          >
        </div>
        <div class="Fuell-Text mt-5 mb-4">
          {{errorMessage}}
        </div>
        <div class="d-flex justify-content-center flex-column mt-5">
          <button
            class="btn btn-primary align-self-center"
            @click="goToSignin"
          > {{$t('ACTION_RETURN_TO_LOGIN')}}</button>
          <span
            class="text-center text-primary clickable mt-3"
            @click="openSupport"
          > <u>{{$t('snackbar_launch_intercom_message')}}</u></span>

        </div>

      </div>
      <div v-else>
        <spinner />
      </div>
    </div>
    <div class="image-side"></div>
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'
import ResetPasswordForm from '../_components/ResetPasswordForm'
import loginApi from '@/modules/login/_api'
import Spinner from '@/components/Commons/Spinner'
export default {
  name: 'ResetPassword',
  components: { ResetPasswordForm, Spinner },
  data () {
    return {
      userResetPasswordTokenData: null,
      userResetTokenExpiredFlag: false,
      userResetTokenNotFoundFlag: false,
      errorMessage: '',
      isCalling: false
    }
  },
  computed: {
    resetToken () {
      return this.$route.params.token
    }
  },
  methods: {
    resetPassword (event) {
      const resetPasswordData = {
        token: this.resetToken,
        password: event.password
      }
      this.$store.dispatch('LoginStore/resetPassword', resetPasswordData).then(() => {
        this.goToSignin()
      })
    },
    async fetchResetPasswordTokenInformation () {
      try {
        this.isCalling = true
        const resetPasswordtoken = this.$route.params.token
        if (!resetPasswordtoken) return
        await loginApi.getResetPasswordToken(resetPasswordtoken)
      } catch (error) {
        console.error(error)
        if (error.response.status === 403) {
          this.userResetTokenExpiredFlag = true
          this.userResetTokenNotFoundFlag = false
          this.errorMessage = this.$i18n.t('user_reset_password_token_expired')
        }
        if (error.response.status !== 403) {
          this.userResetTokenExpiredFlag = false
          this.userResetTokenNotFoundFlag = true
          this.errorMessage = this.$i18n.t('user_reset_password_token_generic_error')
        }
      } finally {
        this.isCalling = false
      }
    },
    async openSupport () {
      const defaultMessage = this.$route && this.$route.path ? this.$t('intercom_predefined_error_message_with_route', { errorMessage: this.errorMessage, routerUrl: this.$route.path }) : this.$t('intercom_predefined_error_message', { errorMessage: this.errorMessage })
      if (window.HubSpotConversations?.widget?.open) {
        window.HubSpotConversations.widget.open(defaultMessage)
      }
    },

    goToSignin () {
      Sentry.setUser(null)
      this.$router.push('/signin')
    }
  },
  async created () {
    await this.fetchResetPasswordTokenInformation()
  }
}
</script>
<style scoped>
.reset-password-logo {
  cursor: pointer;
}
</style>

<style scoped>
.reset-password-view {
  display: flex;
  height: 100vh;
}

.reset-password-view .form-side {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.reset-password-view .image-side {
  display: none;
}

.reset-password-view .form-side .reset-password-pane {
  max-width: 375px;
  width: 100%;
  padding: 0 25px;
}

.reset-password-pane--error {
  max-width: 450px;
  width: 100%;
  padding: 0 10px;
}
.reset-password-view .form-side .reset-password-pane .logo {
  margin-bottom: 47px;
  text-align: center;
}

/* Tablet breakpoint */
@media only screen and (min-width: 600px) {
}

/* Desktop breakpoint */
@media only screen and (min-width: 768px) {
  .reset-password-view .form-side {
    width: 50%;
  }

  .reset-password-view .image-side {
    width: 50%;
    display: block;
    background-image: url("~@/assets/img/login-landing-image.jpg");
    background-position: center center;
    background-size: cover;
  }
}
</style>
